import { Checkbox, Form, Input, Row } from "antd";
import React from "react";

const TruocDieuTri = () => {
  const data2 = [
    {
      key: 1,
      noiDung: "Thị lực (không kính)",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Khúc xạ TĐ",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Khúc xạ (chỉnh kính tối đa)",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Chỉ số K",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "HVID (mm)",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Giác mạc",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Kết mạc",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Tiền sử bệnh lý mắt (nếu có, ghi rõ)",
      mp: "",
      mt: "",
    },
  ];

  const renderCell = (i: number | string, side: string) => {
    if (i == 2 || i === 3) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["ttTruocDieuTri", side, i, 0]}>
              <Input />
            </Form.Item>
          </td>
          <td>
            <Form.Item name={["ttTruocDieuTri", side, i, 1]}>
              <Input />
            </Form.Item>
          </td>
        </td>
      );
    } else if (i === 5 || i === 6) {
      return (
        <td>
          <Form.Item
            name={["ttTruocDieuTri", side, i, "tot"]}
            valuePropName="checked"
          >
            <Checkbox>Tốt</Checkbox>
          </Form.Item>
          <Form.Item
            name={["ttTruocDieuTri", side, i, "khongTot"]}
            valuePropName="checked"
          >
            <Checkbox>Không tốt</Checkbox>
          </Form.Item>
        </td>
      );
    } else
      return (
        <td>
          <Form.Item name={["ttTruocDieuTri", side, i]}>
            <Input />
          </Form.Item>
        </td>
      );
  };
  return (
    <table>
      <thead>
        <th>Nội dung</th>
        <th>MP</th>
        <th>MT</th>
      </thead>
      <tbody>
        {data2.map((e, i) => (
          <tr>
            <td>{e.noiDung}</td>
            {renderCell(i, "mp")}
            {renderCell(i, "mt")}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TruocDieuTri;
